<template>
    <div class="md:w-5/6 lg:w-3/4 xl:w-2/3 mx-auto">
        <form
            ref="form"
            action="/user/subscriptions/search"
            method="POST"
            @keydown.enter="onSubmit(form)"
            @submit.prevent="onSubmit(form)"
        >
            <div
                class="mt-4 bg-white py-5 px-4 sm:rounded-lg sm:shadow-md sm:border sm:border-gray-200 sm:p-6"
            >
                <div class="md:grid md:grid-cols-2 md:gap-6">
                    <div class="mt-0 md:col-span-2">
                        <input type="hidden" name="_token" :value="csrf" />

                        <div class="grid grid-cols-6 gap-6">
                            <div class="col-span-6 sm:col-span-2">
                                <label
                                    for="status"
                                    class="block text-sm font-medium text-gray-700"
                                >
                                    Status
                                </label>

                                <div class="mt-1 relative rounded-md shadow-sm">
                                    <select
                                        v-model="inputs.status"
                                        :ref="refs.status"
                                        id="status"
                                        name="status"
                                        :class="[
                                            hasError(errors, 'status')
                                                ? 'border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500 pr-14'
                                                : 'focus:ring-nutreance-green focus:border-nutreance-green',
                                            'mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none sm:text-sm',
                                        ]"
                                        :aria-invalid="
                                            hasError(errors, 'status')
                                                ? 'true'
                                                : 'false'
                                        "
                                        :aria-describedby="
                                            hasError(errors, 'status')
                                                ? 'status-error'
                                                : ''
                                        "
                                    >
                                        <option value="" selected>All</option>
                                        <option
                                            v-for="(
                                                statusOption, statusOptionId
                                            ) in statusOptions"
                                            :key="statusOptionId"
                                            :value="statusOptionId"
                                        >
                                            {{ statusOption }}
                                        </option>
                                    </select>
                                    <div
                                        v-if="hasError(errors, 'status')"
                                        class="absolute inset-y-0 right-0 pr-8 flex items-center pointer-events-none"
                                    >
                                        <ExclamationCircleIcon
                                            class="h-5 w-5 text-red-500"
                                            aria-hidden="true"
                                        />
                                    </div>
                                </div>
                                <p
                                    v-if="hasError(errors, 'status')"
                                    class="mt-2 text-sm text-red-600"
                                    id="status-error"
                                >
                                    {{ error(errors, "status") }}
                                </p>
                            </div>

                            <div class="col-span-6 sm:col-span-2">
                                <label
                                    for="public_order_id"
                                    class="block text-sm font-medium text-gray-700"
                                >
                                    Order ID
                                </label>
                                <div class="mt-1 relative rounded-md shadow-sm">
                                    <input
                                        v-model="inputs.public_order_id"
                                        :ref="refs.public_order_id"
                                        id="public_order_id"
                                        name="public_order_id"
                                        type="text"
                                        :class="[
                                            hasError(errors, 'public_order_id')
                                                ? 'border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500 pr-10'
                                                : 'focus:ring-nutreance-green focus:border-nutreance-green',
                                            'appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none sm:text-sm',
                                        ]"
                                        :aria-invalid="
                                            hasError(errors, 'public_order_id')
                                                ? 'true'
                                                : 'false'
                                        "
                                        :aria-describedby="
                                            hasError(errors, 'public_order_id')
                                                ? 'public_order_id-error'
                                                : ''
                                        "
                                    />
                                    <div
                                        v-if="
                                            hasError(errors, 'public_order_id')
                                        "
                                        class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
                                    >
                                        <ExclamationCircleIcon
                                            class="h-5 w-5 text-red-500"
                                            aria-hidden="true"
                                        />
                                    </div>
                                </div>
                                <p
                                    v-if="hasError(errors, 'public_order_id')"
                                    class="mt-2 text-sm text-red-600"
                                    id="public_order_id-error"
                                >
                                    {{ error(errors, "public_order_id") }}
                                </p>
                            </div>

                            <div class="col-span-6 sm:col-span-2">
                                <label
                                    for="public_subscription_id"
                                    class="block text-sm font-medium text-gray-700"
                                >
                                    Subscription ID
                                </label>
                                <div class="mt-1 relative rounded-md shadow-sm">
                                    <input
                                        v-model="inputs.public_subscription_id"
                                        :ref="refs.public_subscription_id"
                                        id="public_subscription_id"
                                        name="public_subscription_id"
                                        type="text"
                                        :class="[
                                            hasError(
                                                errors,
                                                'public_subscription_id',
                                            )
                                                ? 'border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500 pr-10'
                                                : 'focus:ring-nutreance-green focus:border-nutreance-green',
                                            'appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none sm:text-sm',
                                        ]"
                                        :aria-invalid="
                                            hasError(
                                                errors,
                                                'public_subscription_id',
                                            )
                                                ? 'true'
                                                : 'false'
                                        "
                                        :aria-describedby="
                                            hasError(
                                                errors,
                                                'public_subscription_id',
                                            )
                                                ? 'public_subscription_id-error'
                                                : ''
                                        "
                                    />
                                    <div
                                        v-if="
                                            hasError(
                                                errors,
                                                'public_subscription_id',
                                            )
                                        "
                                        class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
                                    >
                                        <ExclamationCircleIcon
                                            class="h-5 w-5 text-red-500"
                                            aria-hidden="true"
                                        />
                                    </div>
                                </div>
                                <p
                                    v-if="
                                        hasError(
                                            errors,
                                            'public_subscription_id',
                                        )
                                    "
                                    class="mt-2 text-sm text-red-600"
                                    id="public_subscription_id-error"
                                >
                                    {{
                                        error(errors, "public_subscription_id")
                                    }}
                                </p>
                            </div>

                            <div class="col-span-6 sm:col-span-3">
                                <label
                                    for="start"
                                    class="block text-sm font-medium text-gray-700"
                                >
                                    Start Date
                                </label>
                                <div class="mt-1 relative rounded-md shadow-sm">
                                    <datepicker
                                        :weekStartsOn="0"
                                        v-model="inputs.start"
                                        :ref="refs.start"
                                        id="start"
                                        name="start"
                                        :class="[
                                            hasError(errors, 'start')
                                                ? 'border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500 pr-10'
                                                : 'focus:ring-nutreance-green focus:border-nutreance-green',
                                            'appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none sm:text-sm',
                                        ]"
                                        :aria-invalid="
                                            hasError(errors, 'start')
                                                ? 'true'
                                                : 'false'
                                        "
                                        :aria-describedby="
                                            hasError(errors, 'start')
                                                ? 'start-error'
                                                : ''
                                        "
                                    />
                                    <div
                                        v-if="hasError(errors, 'start')"
                                        class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
                                    >
                                        <ExclamationCircleIcon
                                            class="h-5 w-5 text-red-500"
                                            aria-hidden="true"
                                        />
                                    </div>
                                </div>
                                <p
                                    v-if="hasError(errors, 'start')"
                                    class="mt-2 text-sm text-red-600"
                                    id="start-error"
                                >
                                    {{ error(errors, "start") }}
                                </p>
                            </div>

                            <div class="col-span-6 sm:col-span-3">
                                <label
                                    for="end"
                                    class="block text-sm font-medium text-gray-700"
                                >
                                    End Date
                                </label>
                                <div class="mt-1 relative rounded-md shadow-sm">
                                    <datepicker
                                        :weekStartsOn="0"
                                        v-model="inputs.end"
                                        :ref="refs.end"
                                        id="end"
                                        name="end"
                                        :class="[
                                            hasError(errors, 'end')
                                                ? 'border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500 pr-10'
                                                : 'focus:ring-nutreance-green focus:border-nutreance-green',
                                            'appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none sm:text-sm',
                                        ]"
                                        :aria-invalid="
                                            hasError(errors, 'end')
                                                ? 'true'
                                                : 'false'
                                        "
                                        :aria-describedby="
                                            hasError(errors, 'end')
                                                ? 'end-error'
                                                : ''
                                        "
                                    />
                                    <div
                                        v-if="hasError(errors, 'end')"
                                        class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
                                    >
                                        <ExclamationCircleIcon
                                            class="h-5 w-5 text-red-500"
                                            aria-hidden="true"
                                        />
                                    </div>
                                </div>
                                <p
                                    v-if="hasError(errors, 'end')"
                                    class="mt-2 text-sm text-red-600"
                                    id="end-error"
                                >
                                    {{ error(errors, "end") }}
                                </p>
                            </div>

                            <div class="col-span-6 sm:col-span-4">
                                <label
                                    for="name"
                                    class="block text-sm font-medium text-gray-700"
                                >
                                    Full Name
                                </label>
                                <div class="mt-1 relative rounded-md shadow-sm">
                                    <input
                                        v-model="inputs.name"
                                        :ref="refs.name"
                                        id="name"
                                        name="name"
                                        type="text"
                                        autocomplete="name"
                                        :class="[
                                            hasError(errors, 'name')
                                                ? 'border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500 pr-10'
                                                : 'focus:ring-nutreance-green focus:border-nutreance-green',
                                            'appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none sm:text-sm',
                                        ]"
                                        :aria-invalid="
                                            hasError(errors, 'name')
                                                ? 'true'
                                                : 'false'
                                        "
                                        :aria-describedby="
                                            hasError(errors, 'name')
                                                ? 'name-error'
                                                : ''
                                        "
                                    />
                                    <div
                                        v-if="hasError(errors, 'name')"
                                        class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
                                    >
                                        <ExclamationCircleIcon
                                            class="h-5 w-5 text-red-500"
                                            aria-hidden="true"
                                        />
                                    </div>
                                </div>
                                <p
                                    v-if="hasError(errors, 'name')"
                                    class="mt-2 text-sm text-red-600"
                                    id="name-error"
                                >
                                    {{ error(errors, "name") }}
                                </p>
                            </div>

                            <div class="col-span-6">
                                <label
                                    for="line1"
                                    class="block text-sm font-medium text-gray-700"
                                >
                                    {{ ucwords(country.line1) }}
                                </label>
                                <div class="mt-1 relative rounded-md shadow-sm">
                                    <input
                                        v-model="inputs.line1"
                                        :ref="refs.line1"
                                        name="line1"
                                        id="line1"
                                        type="text"
                                        placeholder=""
                                        autocomplete="address-line1"
                                        :class="[
                                            hasError(errors, 'line1')
                                                ? 'border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500 pr-10'
                                                : 'focus:ring-nutreance-green focus:border-nutreance-green',
                                            'appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none sm:text-sm',
                                        ]"
                                        :aria-invalid="
                                            hasError(errors, 'line1')
                                                ? 'true'
                                                : 'false'
                                        "
                                        :aria-describedby="
                                            hasError(errors, 'line1')
                                                ? 'line1-error'
                                                : ''
                                        "
                                    />
                                    <div
                                        v-if="hasError(errors, 'line1')"
                                        class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
                                    >
                                        <ExclamationCircleIcon
                                            class="h-5 w-5 text-red-500"
                                            aria-hidden="true"
                                        />
                                    </div>
                                </div>
                                <p
                                    v-if="hasError(errors, 'line1')"
                                    class="mt-2 text-sm text-red-600"
                                    id="line1-error"
                                >
                                    {{ error(errors, "line1") }}
                                </p>
                            </div>

                            <div class="col-span-6">
                                <label
                                    for="line2"
                                    class="block text-sm font-medium text-gray-700"
                                >
                                    {{ ucwords(country.line2) }}
                                </label>

                                <div class="mt-1 relative rounded-md shadow-sm">
                                    <input
                                        v-model="inputs.line2"
                                        :ref="refs.line2"
                                        name="line2"
                                        id="line2"
                                        type="text"
                                        autocomplete="address-line2"
                                        :class="[
                                            hasError(errors, 'line2')
                                                ? 'border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500 pr-10'
                                                : 'focus:ring-nutreance-green focus:border-nutreance-green',
                                            'appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none sm:text-sm',
                                        ]"
                                        :aria-invalid="
                                            hasError(errors, 'line2')
                                                ? 'true'
                                                : 'false'
                                        "
                                        :aria-describedby="
                                            hasError(errors, 'line2')
                                                ? 'line2-error'
                                                : ''
                                        "
                                    />
                                    <div
                                        v-if="hasError(errors, 'line2')"
                                        class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
                                    >
                                        <ExclamationCircleIcon
                                            class="h-5 w-5 text-red-500"
                                            aria-hidden="true"
                                        />
                                    </div>
                                </div>
                                <p
                                    v-if="hasError(errors, 'line2')"
                                    class="mt-2 text-sm text-red-600"
                                    id="line2-error"
                                >
                                    {{ error(errors, "line2") }}
                                </p>
                            </div>

                            <div
                                v-if="country.city"
                                class="col-span-6 sm:col-span-6 lg:col-span-3"
                            >
                                <label
                                    for="city"
                                    class="block text-sm font-medium text-gray-700"
                                >
                                    {{ ucwords(country.city) }}
                                </label>

                                <div class="mt-1 relative rounded-md shadow-sm">
                                    <input
                                        v-model="inputs.city"
                                        :ref="refs.city"
                                        name="city"
                                        id="city"
                                        type="text"
                                        autocomplete="address-level2"
                                        :class="[
                                            hasError(errors, 'city')
                                                ? 'border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500 pr-10'
                                                : 'focus:ring-nutreance-green focus:border-nutreance-green',
                                            'appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none sm:text-sm',
                                        ]"
                                        :aria-invalid="
                                            hasError(errors, 'city')
                                                ? 'true'
                                                : 'false'
                                        "
                                        :aria-describedby="
                                            hasError(errors, 'city')
                                                ? 'city-error'
                                                : ''
                                        "
                                    />
                                    <div
                                        v-if="hasError(errors, 'city')"
                                        class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
                                    >
                                        <ExclamationCircleIcon
                                            class="h-5 w-5 text-red-500"
                                            aria-hidden="true"
                                        />
                                    </div>
                                </div>
                                <p
                                    v-if="hasError(errors, 'city')"
                                    class="mt-2 text-sm text-red-600"
                                    id="city-error"
                                >
                                    {{ error(errors, "city") }}
                                </p>
                            </div>

                            <div
                                v-if="country.state"
                                class="col-span-6 sm:col-span-3"
                            >
                                <label
                                    for="state"
                                    class="block text-sm font-medium text-gray-700"
                                >
                                    {{ ucwords(country.state) }}
                                </label>

                                <div class="mt-1 relative rounded-md shadow-sm">
                                    <input
                                        v-if="isEmpty(states)"
                                        v-model="inputs.state"
                                        :ref="refs.state"
                                        name="state"
                                        id="state"
                                        type="text"
                                        autocomplete="address-level1"
                                        :class="[
                                            hasError(errors, 'state')
                                                ? 'border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500 pr-10'
                                                : 'focus:ring-nutreance-green focus:border-nutreance-green',
                                            'appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none sm:text-sm',
                                        ]"
                                        :aria-invalid="
                                            hasError(errors, 'state')
                                                ? 'true'
                                                : 'false'
                                        "
                                        :aria-describedby="
                                            hasError(errors, 'state')
                                                ? 'state-error'
                                                : ''
                                        "
                                    />
                                    <select
                                        v-else
                                        v-model="inputs.state"
                                        :ref="refs.state"
                                        id="state"
                                        name="state"
                                        autocomplete="address-level1"
                                        :class="[
                                            hasError(errors, 'state')
                                                ? 'border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500 pr-14'
                                                : 'focus:ring-nutreance-green focus:border-nutreance-green',
                                            'mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none sm:text-sm',
                                        ]"
                                        :aria-invalid="
                                            hasError(errors, 'state')
                                                ? 'true'
                                                : 'false'
                                        "
                                        :aria-describedby="
                                            hasError(errors, 'state')
                                                ? 'state-error'
                                                : ''
                                        "
                                    >
                                        <option
                                            value=""
                                            disabled
                                            hidden
                                            selected
                                        >
                                            --- Select a
                                            {{ ucwords(country.state) }} ---
                                        </option>
                                        <option
                                            v-for="(state, code) in states"
                                            :key="code"
                                            :value="code"
                                        >
                                            {{ state }}
                                        </option>
                                    </select>
                                    <div
                                        v-if="hasError(errors, 'state')"
                                        :class="[
                                            isEmpty(states) ? 'pr-3' : 'pr-8',
                                            'absolute inset-y-0 right-0 flex items-center pointer-events-none',
                                        ]"
                                    >
                                        <ExclamationCircleIcon
                                            class="h-5 w-5 text-red-500"
                                            aria-hidden="true"
                                        />
                                    </div>
                                </div>
                                <p
                                    v-if="hasError(errors, 'state')"
                                    class="mt-2 text-sm text-red-600"
                                    id="state-error"
                                >
                                    {{ error(errors, "state") }}
                                </p>
                            </div>

                            <div
                                v-if="country.postal_code"
                                class="col-span-6 sm:col-span-3 lg:col-span-2"
                            >
                                <label
                                    for="postal_code"
                                    class="block text-sm font-medium text-gray-700"
                                >
                                    {{ ucwords(country.postal_code) }}
                                </label>

                                <div class="mt-1 relative rounded-md shadow-sm">
                                    <input
                                        v-model="inputs.postal_code"
                                        :ref="refs.postal_code"
                                        name="postal_code"
                                        id="postal_code"
                                        type="text"
                                        autocomplete="postal-code"
                                        :class="[
                                            hasError(errors, 'postal_code')
                                                ? 'border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500 pr-10'
                                                : 'focus:ring-nutreance-green focus:border-nutreance-green',
                                            'appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none sm:text-sm',
                                        ]"
                                        :aria-invalid="
                                            hasError(errors, 'postal_code')
                                                ? 'true'
                                                : 'false'
                                        "
                                        :aria-describedby="
                                            hasError(errors, 'postal_code')
                                                ? 'postal_code-error'
                                                : ''
                                        "
                                    />
                                    <div
                                        v-if="hasError(errors, 'postal_code')"
                                        class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
                                    >
                                        <ExclamationCircleIcon
                                            class="h-5 w-5 text-red-500"
                                            aria-hidden="true"
                                        />
                                    </div>
                                </div>
                                <p
                                    v-if="hasError(errors, 'postal_code')"
                                    class="mt-2 text-sm text-red-600"
                                    id="postal_code-error"
                                >
                                    {{ error(errors, "postal_code") }}
                                </p>
                            </div>

                            <div class="col-span-6 sm:col-span-4">
                                <label
                                    for="country_code"
                                    class="block text-sm font-medium text-gray-700"
                                >
                                    Country
                                </label>

                                <div class="mt-1 relative rounded-md shadow-sm">
                                    <select
                                        v-model="inputs.country_code"
                                        :ref="refs.country_code"
                                        @change="updateCountry"
                                        id="country_code"
                                        name="country_code"
                                        autocomplete="country"
                                        :class="[
                                            hasError(errors, 'country_code')
                                                ? 'border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500 pr-14'
                                                : 'focus:ring-nutreance-green focus:border-nutreance-green',
                                            'mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none sm:text-sm',
                                        ]"
                                        :aria-invalid="
                                            hasError(errors, 'country_code')
                                                ? 'true'
                                                : 'false'
                                        "
                                        :aria-describedby="
                                            hasError(errors, 'country_code')
                                                ? 'country_code-error'
                                                : ''
                                        "
                                    >
                                        <option
                                            value=""
                                            disabled
                                            hidden
                                            selected
                                        >
                                            --- Select a Country ---
                                        </option>
                                        <option
                                            v-for="(country, code) in countries"
                                            :key="code"
                                            :value="code"
                                        >
                                            {{ country }}
                                        </option>
                                    </select>
                                    <div
                                        v-if="hasError(errors, 'country_code')"
                                        class="absolute inset-y-0 right-0 pr-8 flex items-center pointer-events-none"
                                    >
                                        <ExclamationCircleIcon
                                            class="h-5 w-5 text-red-500"
                                            aria-hidden="true"
                                        />
                                    </div>
                                </div>
                                <p
                                    v-if="hasError(errors, 'country_code')"
                                    class="mt-2 text-sm text-red-600"
                                    id="country_code-error"
                                >
                                    {{ error(errors, "country_code") }}
                                </p>
                            </div>

                            <div class="col-span-6 sm:col-span-3">
                                <label
                                    for="email"
                                    class="block text-sm font-medium text-gray-700"
                                >
                                    Email
                                </label>

                                <div class="mt-1 relative rounded-md shadow-sm">
                                    <input
                                        v-model="inputs.email"
                                        :ref="refs.email"
                                        name="email"
                                        id="email"
                                        type="text"
                                        autocomplete="email"
                                        :class="[
                                            hasError(errors, 'email')
                                                ? 'border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500 pr-10'
                                                : 'focus:ring-nutreance-green focus:border-nutreance-green',
                                            'appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none sm:text-sm',
                                        ]"
                                        :aria-invalid="
                                            hasError(errors, 'email')
                                                ? 'true'
                                                : 'false'
                                        "
                                        :aria-describedby="
                                            hasError(errors, 'email')
                                                ? 'email-error'
                                                : ''
                                        "
                                    />
                                    <div
                                        v-if="hasError(errors, 'email')"
                                        class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
                                    >
                                        <ExclamationCircleIcon
                                            class="h-5 w-5 text-red-500"
                                            aria-hidden="true"
                                        />
                                    </div>
                                </div>
                                <p
                                    v-if="hasError(errors, 'email')"
                                    class="mt-2 text-sm text-red-600"
                                    id="email-error"
                                >
                                    {{ error(errors, "email") }}
                                </p>
                            </div>

                            <div class="col-span-6 sm:col-span-3">
                                <label
                                    for="phone"
                                    class="block text-sm font-medium text-gray-700"
                                >
                                    Phone
                                </label>

                                <div class="mt-1 relative rounded-md shadow-sm">
                                    <input
                                        v-model="inputs.phone"
                                        :ref="refs.phone"
                                        name="phone"
                                        id="phone"
                                        type="tel"
                                        autocomplete="phone"
                                        :class="[
                                            hasError(errors, 'phone')
                                                ? 'border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500 pr-10'
                                                : 'focus:ring-nutreance-green focus:border-nutreance-green',
                                            'appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none sm:text-sm',
                                        ]"
                                        :aria-invalid="
                                            hasError(errors, 'phone')
                                                ? 'true'
                                                : 'false'
                                        "
                                        :aria-describedby="
                                            hasError(errors, 'phone')
                                                ? 'phone-error'
                                                : ''
                                        "
                                    />
                                    <div
                                        v-if="hasError(errors, 'phone')"
                                        class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
                                    >
                                        <ExclamationCircleIcon
                                            class="h-5 w-5 text-red-500"
                                            aria-hidden="true"
                                        />
                                    </div>
                                </div>
                                <p
                                    v-if="hasError(errors, 'phone')"
                                    class="mt-2 text-sm text-red-600"
                                    id="phone-error"
                                >
                                    {{ error(errors, "phone") }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="sm:px-6 py-6 flex justify-center items-center">
                <div class="w-2/5 sm:w-1/3 pr-1 sm:pr-4">
                    <a
                        role="button"
                        href="/user/subscriptions"
                        class="inline-flex justify-center items-center px-6 py-3 border border-transparent rounded-md shadow-sm font-medium text-white bg-red-500 hover:bg-red-600 focus:outline-none w-full"
                    >
                        <XIcon class="h-5 w-5 mr-2" aria-hidden="true" />
                        Cancel
                    </a>
                </div>

                <div class="w-3/5 sm:w-2/3 pl-1 sm:pl-4">
                    <button
                        name="search"
                        type="submit"
                        class="inline-flex justify-center items-center px-6 py-3 border border-transparent rounded-md shadow-sm font-medium text-white bg-nutreance-green hover:bg-nutreance-green-darker focus:outline-none w-full"
                    >
                        <SearchIcon class="h-5 w-5 mr-2" aria-hidden="true" />
                        Search
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<script setup lang="ts">
import { onMounted, reactive, ref } from "vue";
import { SearchIcon } from "@heroicons/vue/outline";
import { ExclamationCircleIcon, XIcon } from "@heroicons/vue/solid";
import { useForm } from "../../functions/useForm";
import { useString } from "../../functions/useString";
import Datepicker from "vue3-datepicker";
import { DateTime } from "luxon";
import { isEmpty } from "lodash";
import { updateCountry as updateCountryRequest } from "../../api/countries";

const props = defineProps<{
    countries?: any;
    csrf?: string;
    errors?: any;
    initialCountry?: any;
    initialStates?: any;
    old?: any;
    statusOptions?: any;
}>();

const { error, hasError, oldInput, onSubmit } = useForm();
const { ucwords } = useString();
const form = ref<any>(null);

const country = ref<any>(props.initialCountry);
const states = ref<any>(props.initialStates);

const refs = {
    status: ref<any>(null),
    public_order_id: ref<any>(null),
    public_subscription_id: ref<any>(null),
    start: ref<any>(new Date()),
    end: ref<any>(new Date()),
    name: ref<any>(null),
    line1: ref<any>(null),
    line2: ref<any>(null),
    city: ref<any>(null),
    state: ref<any>(null),
    postal_code: ref<any>(null),
    country_code: ref<any>(null),
    email: ref<any>(null),
    phone: ref<any>(null),
};

const inputs = reactive<Record<string, any>>({
    status: oldInput(props.old, "status") ? oldInput(props.old, "status") : "",
    public_order_id: oldInput(props.old, "public_order_id"),
    public_subscription_id: oldInput(props.old, "public_subscription_id"),
    start: oldInput(props.old, "start")
        ? DateTime.fromISO(oldInput(props.old, "start")).toJSDate()
        : null,
    end: oldInput(props.old, "end")
        ? DateTime.fromISO(oldInput(props.old, "end")).toJSDate()
        : null,
    name: oldInput(props.old, "name"),
    line1: oldInput(props.old, "line1"),
    line2: oldInput(props.old, "line2"),
    city: oldInput(props.old, "city"),
    state: oldInput(props.old, "state") ? oldInput(props.old, "state") : "",
    postal_code: oldInput(props.old, "postal_code"),
    country_code: oldInput(props.old, "country_code")
        ? oldInput(props.old, "country_code")
        : "",
    email: oldInput(props.old, "email"),
    phone: oldInput(props.old, "phone"),
});

function updateCountry() {
    updateCountryRequest({
        country_code: inputs.country_code,
    }).then((data) => {
        country.value = data.country;
        states.value = data.states;
    });
}

onMounted(() => {
    switch (true) {
        case !!hasError(props.errors, "status"):
            return refs.status.value.focus();
        case !!hasError(props.errors, "public_order_id"):
            return refs.public_order_id.value.focus();
        case !!hasError(props.errors, "public_subscription_id"):
            return refs.public_subscription_id.value.focus();
        case !!hasError(props.errors, "name"):
            return refs.name.value.focus();
        case !!hasError(props.errors, "line1"):
            return refs.line1.value.focus();
        case !!hasError(props.errors, "line2"):
            return refs.line2.value.focus();
        case !!hasError(props.errors, "city"):
            return refs.city.value.focus();
        case !!hasError(props.errors, "state"):
            return refs.state.value.focus();
        case !!hasError(props.errors, "postal_code"):
            return refs.postal_code.value.focus();
        case !!hasError(props.errors, "country_code"):
            return refs.country_code.value.focus();
        case !!hasError(props.errors, "email"):
            return refs.email.value.focus();
        case !!hasError(props.errors, "phone"):
            return refs.phone.value.focus();
        default:
            return refs.public_order_id.value.focus();
    }
});
</script>
